import HeaderMenu from '../components/header';
import FooterBar from './footer';
import { createStyles } from '@mantine/core';
import { useEffect, useState } from 'react';
import API from '../apis/api';
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from '../apis/response/GetNavbarCategoriesResponse';
import { PortalLink, GetPortalResponse, ToPortalLink } from '../apis/response/GetPortalResponse';
import ImageStorageService from '../services/ImageStorageService';
import { TranslationService } from '../services/TranslationService';
import { TranslateField } from '../types/translate-field';
import { CategoryMap } from './category-navbar';
import { Outlet } from 'react-router-dom';

const useStyles = createStyles((theme) => ({
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflow: 'visible'
  },
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    // padding: '15px',
    width: '100%'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    flex: '1'
  }
}));

export interface LayoutProps {
  hideFooter?: boolean
}

const Layout = (props: LayoutProps) => {
  const { classes } = useStyles()
  const hidefooter = props.hideFooter ?? false
  const [logo, setLogo] = useState('')
  const links: PortalLink[] = []
  const [useful, setUseful] = useState(links)
  const map: CategoryMap = { categories: [], departments: [] }
  const [categories, setCategories] = useState(map)
  const footer: TranslateField[] = []
  const [footerFields, setFooterFields] = useState(footer)
  const [locale, setLocale] = useState('en')

  const fetchData = async () => {
    const imageService = new ImageStorageService()

    const res: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj
    setCategories(TransformToCategoryMenu(res.items))

    const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
    setUseful(usefulRes.items.map(x => ToPortalLink(x)))

    const logoRes: { items: string } = (await API.ImageStorage.Get('HKC Logo')).obj
    setLogo(imageService.FormatImageSrc(logoRes.items))


    const translateService = new TranslationService()
    setFooterFields(await translateService.GetFooterProps())

    return {
      categories,
      useful,
      logo
    }
  }
  useEffect(() => {
    fetchData()
  }, [])
  return (
    <div className={classes.container}>
      <HeaderMenu logo={logo} categories={categories} useful={useful}/>
      <div className={classes.content}>
        <div className={classes.pageContainer}>
          <Outlet />
        </div>
      </div>
      { !hidefooter ? <FooterBar footerFields={footerFields} locale={locale}/> : <></> }
    </div>
  )
}

export default Layout
